<cs-events-wrapper
  #embeddedElement
  [events]="(eventListEmbeddedStore.events$ | async)!"
  [loading]="(eventListEmbeddedStore.isLoading$ | async)!"
  [onEventClick]="onEventClick"
  >
</cs-events-wrapper>

